<div class="nav-container-2" [hidden]="selectedTabIndex==0">
    <div class="d-flex justify-content-between">
        <mat-tab-group (selectedTabChange)="viewTabClick($event)" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="" id="lblcommunication" class="primary"></mat-tab>
            <mat-divider [vertical]="true"></mat-divider>
            <mat-tab *ngFor="let tab of viewTrasmittalTabs; let index = index" [label]="tab.message_No" class="tabsrow">
                <ng-template mat-tab-label>
                    {{tab.message_No}}
                    <i class="fa fa-times-circle ml-3" (click)="closeTabClick(tab)" aria-hidden="true"></i>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
<div class="" *ngIf="selectedTabIndex==0">
    <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
        <kendo-grid #transmittalGrid [kendoGridBinding]="gridData" [height]="550" [pageable]="true" [pageSize]="pageSize" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" (selectionChange)="onSelectionChange($event)" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid" (mouseover)="onHover($event)">
            <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                    <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                    <kendo-pager-input></kendo-pager-input>
                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
                <div class="k-grid-toolbar-content d-flex">
                    <div class="flex-grow-1 title-container">
                        <!-- <p class="title">Details -</p>
                        <div class="pagination-container details-section">
                            <p class="d-none d-sm-flex">Viewing last</p>
                            <kendo-dropdownlist [data]='noOfDays' [value]="LastViewingRecord" (valueChange)="lastviewingrecordsmethod($event)" class="eip-mr-5 eip-ml-5" id="lblViewingLastDaysRecords" style="margin: 0px;"> </kendo-dropdownlist>
                            <p class="d-none d-sm-flex">days records</p>
                        </div> -->
                    </div>
                    <div class="pagination-container">
                        <p id="lblShowDetails">Show</p>
                        <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                        </kendo-pager-page-sizes>
                        <span>Items</span>
                    </div>
                    <div class="divider-container d-none d-md-block" id="imgDivider">
                        <span></span>
                    </div>
                    <div class="icons-container">
                        <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                        <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">                           
                            <div class="icon-wrap">
                                <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                <span class="list-icon-name">Filter</span>
                            </div>
                            <div class="icon-wrap">
                                <span class="list-icon-name">Grid Settings</span>
                            </div>
                            <div class="icon-wrap" (click)="toggleFullscreen()">
                                <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                            </div>
                            <div class="icon-wrap">
                                <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">&nbsp;&nbsp;Export to Excel</button>
                            </div>
                            <div class="divider-container d-none d-md-block" id="imgDivider">
                                <span></span>
                            </div>
                            <div class="icon-wrap">
                                <i class="fa fa-plus-circle" aria-hidden="true" title="Create Transmittal" (click)="createTransmittalClick()"></i>
                                <span class="list-icon-name">Create Transmittal</span>
                            </div>
                            <div class="icon-wrap">
                                <i class="fa fa-binoculars" aria-hidden="true" title="View Transmittal" (click)="viewTransmittalsClick()"></i>
                                <span class="list-icon-name">View Transmittal</span>
                            </div>                           
                            <div class="icon-wrap">
                                <i class="fa fa-question-circle" aria-hidden="true" title="Help Manual" (click)="HelpUrlClick()"></i>
                                <span class="list-icon-name">Help Manual</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <kendo-grid-checkbox-column showSelectAll="true" [width]="25"></kendo-grid-checkbox-column>
            <kendo-grid-column [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <i aria-hidden="true" title="Attachment" *ngIf="dataItem.has_Attachments"  (click)="viewAttachmentClick(dataItem)" class="fa fa-paperclip fs-16 eip-mr-5 eip-link"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="message_Number" title="Transmittal No" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap eip-link" eipTooltip="{{dataItem.message_Number}}" eipTooltipPosition="auto" (click)="viewTransmittalClick(dataItem)" style=" display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.message_Number}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="message_Subject" title="Subject" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.message_Subject}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.message_Subject}}
                    </span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="gridData" Field="message_Subject"></app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="discipline_Description" title="Discipline" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.discipline_Description}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.discipline_Description}}
                    </span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="gridData" Field="discipline_Description"></app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentNo" title="Documents" [width]="300">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.documentNo}}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="respond_On" title="Sent On" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.respond_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">
                        {{dataItem.respond_On| date:'dd-MMM-yyyy'}}
                    </span>
                    <span class="k-grid-status" [class.cancelled]="" [class.rejected]="" [class.submitted]="" [class.draft]="" [class.approved]="" [class.send_back]="" [class.hold]="" [class.accepted]="" [class.closed]="" [class.amber]="" [class.amber]="" [class.amber]=""></span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-datepicker-filter [filter]="filter" field="respond_On"></app-datepicker-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="action" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <i class="fa fa-pencil" title="Edit" (click)="viewDci(dataItem)" *ngIf="dataItem.message_Id.toString()==dataItem.message_Number" aria-hidden="true"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel fileName="TransmittalList.xlsx" [fetchData]="allData"></kendo-grid-excel>
        </kendo-grid>
    </div>
</div>
<div *ngIf="selectedTabIndex!=0">
    <button class="btn btn-primary" id="exportWord" (click)="exportToWord()"><i class="fa fa-file-word-o" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Export Word</button>
    <div class="row justify-content-center">
        <app-transmittal-view #transmittalViewComponent id="TransmittalComponent" [transmittalData]="viewTransmittalData">
        </app-transmittal-view>
    </div>
    <div class="row m-0 justify-content-center" *ngIf="isDTNReleased">
        <button class="btn btn-primary eip-ml-10" id="btnSendMail" (click)="sendMail(true)"><i class="fa fa-consignee-debit-note" title="Send Mail" aria-hidden="true"></i>&nbsp;&nbsp;Send Mail</button>
    </div>
</div>